import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './FavoriteStar.css';

interface FavoriteStarProps {
  contentId: string;
  contentType: string;
  title?: string; // Добавляем опциональный title
}

const FavoriteStar: React.FC<FavoriteStarProps> = ({ contentId, contentType, title }) => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [isFavorite, setIsFavorite] = useState(false);




  // Проверка избранного
  useEffect(() => {
    if (!isAuthenticated || !user) return;

    const checkFavorite = async () => {
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: 'https://sergey-mavrodi.com/api',
            scope: 'read:favorites',
          },
        });
        const response = await fetch(`/api/favorites/${user.sub}/${contentType}/${contentId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        setIsFavorite(data.isFavorite);
      } catch (error) {
        console.error('Ошибка при проверке избранного:', error);
      }
    };

    checkFavorite();
  }, [isAuthenticated, user, contentId, contentType, getAccessTokenSilently]);

  // Обработчик клика
  const toggleFavorite = async () => {
    if (!isAuthenticated) {
      alert('Необходимо войти в ЛК, чтобы добавить в Избранное.');
      return;
    }

    try {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: 'https://sergey-mavrodi.com/api',
          scope: 'write:favorites',
        },
      });
      const method = isFavorite ? 'DELETE' : 'POST';
      const response = await fetch('/api/favorites', {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId: user?.sub,
          contentId,
          contentType,
          title: title || '', // Используем title с fallback на пустую строку
        }),
      });

      if (response.ok) {
        setIsFavorite(!isFavorite);
      } else {
        console.error('Ошибка при обновлении избранного');
      }
    } catch (error) {
      console.error('Ошибка:', error);
    }
  };


  return (
    <button className={`favorite-star ${isFavorite ? 'filled' : ''}`} onClick={toggleFavorite}
    aria-label="Избранное">
      <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill={isFavorite ? '#FFD700' : 'none'}
  stroke="#000000"
  strokeWidth="1"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <polygon points="
    22.000,12.000 
    16.763,14.750 
    17.000,20.660 
    12.000,17.500 
    7.000,20.660 
    7.237,14.750 
    2.000,12.000 
    7.237,9.250 
    7.000,3.340 
    12.000,6.500 
    17.000,3.340 
    16.763,9.250
  " />
</svg>
    </button>
  );
};

export default FavoriteStar;